import uuid from "react-uuid";


// Function to generate a random UUID
export const generateUUID = ()=>{
    return uuid();
}

